import { addMainImage } from "@/business/inventory/application/addMainImage";
import { addSliderImages } from "@/business/inventory/application/addSliderImages";
import { deleteInventoryImage } from "@/business/inventory/application/deleteInventoryImage";
import { deleteInventoryItem } from "@/business/inventory/application/deleteInventoryItem";
import { exportImagesLastUpdateExcel } from "@/business/inventory/application/exportImagesLastUpdateExcel";
import { getMainImagesWeb } from "@/business/inventory/application/getMainImagesWeb";
import {
  AdditionalImage,
  Reference,
} from "@/business/inventory/domain/inventory";
import { ref, Ref, onMounted } from "vue";
import { useRouter } from "vue-router";

export function sampleBookUse() {
  const router = useRouter();
  const references: Ref<Reference[]> = ref([]);
  const selectedReference: Ref<Reference | null> = ref(null);
  const modalInfoSample: Ref<boolean> = ref(false);
  const modalInventoryImage: Ref<boolean> = ref(false);
  const isEdit: Ref<string> = ref("false");
  const selectedAdditional: Ref<AdditionalImage | null> = ref(null);
  const additionalPosition: Ref<number> = ref(0);
  const route: Ref<string> = ref("");

  onMounted(async () => {
    references.value = await getMainImagesWeb.execute();
    selectedReference.value = references.value[0];
    route.value = await exportImagesLastUpdateExcel.execute();
  });

  async function buildPrimaryReferenceOperation(
    reference: string,
    description: string,
    image: File
  ) {
    await addMainImage.execute(reference, description, image, isEdit.value);

    await refreshReferences();

    selectedReference.value =
      references.value.find((item) => item.reference == reference) ?? null;
  }

  async function buildSecondaryReferenceOperation(
    slider: File | null,
    bigImage: File | null
  ) {
    const isBigImage = bigImage !== null ? "true" : "false";
    const isSlider = slider !== null ? "true" : "false";

    await addSliderImages.execute(
      additionalPosition.value,
      isSlider,
      isBigImage,
      selectedReference.value?.reference ?? "",
      slider,
      bigImage
    );

    await refreshReferences();
    selectedReference.value =
      references.value.find(
        (reference) => reference.reference == selectedReference.value?.reference
      ) ?? null;
    modalInventoryImage.value = false;
  }

  async function deletePrimaryReferenceOperation(): Promise<void> {
    const referenceToDelete = selectedReference.value;

    if (referenceToDelete !== null) {
      await deleteInventoryItem.execute(referenceToDelete.reference);

      references.value = references.value.filter(
        (reference) => reference.reference !== referenceToDelete.reference
      );
    }
  }

  async function deleteSecondaryReferenceOperation(
    position: number
  ): Promise<void> {
    await deleteInventoryImage.execute(
      selectedReference.value?.reference ?? "",
      position
    );
    await refreshReferences();
    selectedReference.value =
      references.value.find(
        (reference) => reference.reference == selectedReference.value?.reference
      ) ?? null;
  }

  function openInventoryImageModal(
    additional: AdditionalImage | null,
    position: number | null
  ) {
    if (additional == null) {
      selectedAdditional.value = {} as AdditionalImage;
      selectedAdditional.value = null;
    } else {
      selectedAdditional.value = null;
      selectedAdditional.value = additional;
    }

    if (
      selectedReference.value !== null &&
      selectedReference.value.additional !== undefined
    ) {
      additionalPosition.value =
        position ?? selectedReference.value.additional.length;
    } else {
      additionalPosition.value = 0;
    }

    modalInventoryImage.value = true;
  }

  function closeInventoryImageModal() {
    modalInventoryImage.value = false;
  }

  function createNewReference() {
    selectedReference.value = null;
    modalInfoSample.value = true;
    isEdit.value = "false";
  }

  function editReference(reference: Reference) {
    selectedReference.value = reference;
    modalInfoSample.value = true;
    isEdit.value = "true";
  }

  function closeInformationSampleModal() {
    modalInfoSample.value = false;
    selectedReference.value = null;
  }

  async function refreshReferences() {
    references.value = await getMainImagesWeb.execute();
  }

  return {
    modalInfoSample,
    closeInformationSampleModal,
    modalInventoryImage,
    closeInventoryImageModal,
    references,
    buildPrimaryReferenceOperation,
    buildSecondaryReferenceOperation,
    deletePrimaryReferenceOperation,
    deleteSecondaryReferenceOperation,
    selectedReference,
    createNewReference,
    editReference,
    openInventoryImageModal,
    selectedAdditional,
    route,
  };
}
